import React from "react";
import PgHomeBase from "../SHARED/components/PgHomeBase";

export default function ProfessionalGuardianHome() {
  return <PgHomeBase variant="guardianUser" />;
}
